import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./ServiceDetails.css";
import { TopSection } from "../../Components";
import { Container } from "react-bootstrap";
import { Service } from "../../Components";
import { useNavigate } from "react-router-dom";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

const ServiceDetails = ({ url, language, translations, loading, setLoading }) => {
  const navigate = useNavigate()
  const [serviceData, setServiceData] = useState(null);
  const [error, setError] = useState(null);
  const { serviceName } = useParams();
  const [show, setShow] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone_number: "",
    message: "",
    subject: ""
  });

  const handleChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    }
  };

  const fetchServiceDetails = async () => {
    // setLoading(true);
    try {
      let apiUrl = `${url}/api/method/geniusapi.www.api.service_details?name=${encodeURIComponent(serviceName)}`;
      const response = await fetch(apiUrl);
      const data = await response.json();

      if (data.result && data.result.length > 0) {
        setServiceData(data.result[0]);
      }
    } catch (err) {
      setError("Failed to load service details");
      console.error(err);
    }
    // setLoading(false);
  };



  const handleServiceClick = (serviceName) => {
    navigate(`/details/${encodeURIComponent(serviceName)}`);
  };

  useEffect(() => {
    if (serviceName) {
      fetchServiceDetails();
    }
  }, [serviceName]);


  if (error) {
    return <div>{error}</div>;
  }

  const { service_name, service_name_ar, description, description_ar, gallery } = serviceData || {};



  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // const send_contact_us = async () => {
  //   console.log("sending:", serviceName);

  // };

  const handleSubmit = async (e) => {

    // Simple front-end validation
    const { full_name, phone_number, email, message } = formData;
    if (!full_name) return toast.error("Full name is required.");
    if (!phone_number) return toast.error("Phone number is required.");
    if (!email) return toast.error("Email is required.");
    if (!message) return toast.error("Message is required.");

    // ✅ Email format validation using RegExp
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return toast.error("Please enter a valid email address.");

    e.preventDefault();
    setIsSubmitting(true);

    const payload = {
      full_name,
      phone_number,
      email,
      service: serviceName,
      message,
    };

    try {
      const response = await fetch(
        `${url}/api/method/geniusapi.genius_api.doctype.contact_us_form.contact_us_form.contact_us_form`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      setIsSubmitting(false)
      if (response.ok) {
        // Handle successful response
        toast.success(
          <>
            Successfully Sent Message
            <br />
            Thank You
          </>
        );
      } else {
        // Handle error response
        toast.error("Failed to send message");
      }
    } catch (error) {
      setIsSubmitting(false)
      // Handle network error
      toast.error("An error occurred. Please try again later.");
    }
    finally {
      setFormData({
        full_name: "",
        email: "",
        phone_number: "",
        message: "",
        subject: ""
      });
      handleClose();
    }
  };

  return (
    <div>
      <TopSection
        title={`${translations?.result?.home} / ${translations?.result?.Services}`}
        subtitle={`/${translations?.result?.InteriorDesign} / ${language === "en" ? service_name : service_name_ar}`}
        image={require("../../Assets/Images/top-sections/details.png")}
      />
      <Container>
        <div className="service-details-title">{language === "en" ? service_name || "" : service_name_ar || ""}</div>
        <div className="service-details-para">
          {language === "en" ? description || "" : description_ar || ""}
          {/* ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nisl leo amet, consectetur adipisci. ipsum dolor sit ametleo amet, consectetur adipisci. ipsum dolor sit ametipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nisl leo amet, consectetur adipisci. ipsum dolor sit ametleo amet, consectetur adipisci. ipsum dolor sit ametipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nisl leo amet, consectetur adipisci. ipsum dolor sit ametleo amet, consectetur adipisci. ipsum dolor sit amet */}
        </div>
        <a className="service-details-btn" data-aos="fade-right" onClick={handleShow}>
          {translations?.result?.ContactConsultant
            ? translations?.result?.ContactConsultant
            : "Contact consultant"}
        </a>
        <div className="service-details-gallery">
          {gallery &&
            gallery.map((item, index) => (
              <div
                key={index}
                className="service-detail-image"
                data-aos="zoom-in"
              >
                <img
                  src={url + item.image}
                  alt={item.alt_text || `Image ${index + 1}`}
                />
              </div>
            ))}
        </div>
        {serviceData && serviceData.services && serviceData.services.length > 0 ? (
          <>
            <div className="service-details-title">{translations?.result?.services
              ? translations?.result?.services
              : "Services"}</div>
            <div className="service-list-content">
              {serviceData.services.map((service, index) => {
                const mainImage = service.gallery.find(item => item.main_image === 1);
                return (
                  <Service
                    key={index}
                    onClick={() => handleServiceClick(service.service_name)}
                    image={mainImage ? url + mainImage.link : require("../../Assets/Images/service-list/1.png")}
                    title={language === "en" ? service.service_name || "" : service.service_name_ar || ""}
                  />
                );
              })}
            </div>
          </>
        ) : (<></>)}

        <Offcanvas show={show} onHide={handleClose}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Contact Consultant</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <form className="contact-consultant-form">
              <div className="mb-3">
                <label htmlFor="fullName" className="form-label">Full Name</label>
                <input type="text" className="form-control" value={formData.full_name} onChange={handleChange} required name="full_name" placeholder="Enter your full name" disabled={isSubmitting}/>
              </div>
              <div className="mb-3">
                <label htmlFor="phone" className="form-label" >Phone Number</label>
                <input type="tel" className="form-control" value={formData.phone_number} onChange={handleChange} required name="phone_number" placeholder="Enter your phone number" disabled={isSubmitting}/>
              </div>
              <div className="mb-3">
                <label htmlFor="email" className="form-label" >Email</label>
                <input type="email" className="form-control" value={formData.email} onChange={handleChange} required name="email" placeholder="Enter your email" disabled={isSubmitting}/>
              </div>
              <div className="mb-3">
                <label htmlFor="message" className="form-label" >Message</label>
                <textarea className="form-control" value={formData.message} onChange={handleChange} required name="message" rows="3" placeholder="Write your message here..." disabled={isSubmitting}></textarea>
              </div>
              <div className="service-list-link">
                <a class="border-animation" style={{ cursor: 'pointer' }} onClick={handleSubmit} disabled={isSubmitting}>Send</a>
              </div>
            </form>
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
      <ToastContainer />
    </div>
  );
};

export default ServiceDetails;
